module.exports = __webpack_public_path__ + "static/img/180153_8.462a466.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/180153_8.jpg
// module id = wxXG
// module chunks = 1